import { useMutation } from '@tanstack/react-query';
import { Identifier, ToastType } from '@types';
import { AxiosRequestConfig } from 'axios';
import { EventLog, IMutationParams, NaturalDisasterConstants, ResultCallBack } from 'shared-ui-components';
import { v4 } from 'uuid';
import { ApiLogger } from 'fmc-digital-common';
import { config } from 'config';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useRequestForbearanceMutation = ({
    forbearanceApiParams,
    onComplete,
    logApiEvent,
    logUserEvent,
    type,
    accessToken,
    currentLoan
}: {
    accessToken: string;
    forbearanceApiParams: IMutationParams;
    type: string;
    currentLoan: Identifier;
} & ResultCallBack &
    EventLog) => {
    const correlationId = v4().toString();
    return useMutation({
        mutationFn: (requestBody: any) => {
            const postConfig: AxiosRequestConfig = {
                method: 'post',
                url: `${forbearanceApiParams.baseAWSUrl}occurrences`,
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                    'x-correlation-id': correlationId,
                    'x-api-key': `${config.env('xApiKey')}`
                },
                data: JSON.stringify(requestBody)
            };
            return ApiLogger(postConfig, logApiEvent);
        },
        onSuccess: async () => {
            onComplete({
                message: NaturalDisasterConstants.SUCCESS_FORBEARANCE_MESSAGE,
                toastType: ToastType.SUCCESS
            });
            logUserEvent({
                type,
                action: `UpdatedBorrowerImpactedNaturalDisasterStatusSuccess`,
                description: `Updated Borrower Impacted NaturalDisaster Status Success`
            });
        },
        onError: () => {
            logUserEvent({
                type,
                action: `UpdatedBorrowerImpactedNaturalDisasterStatusFailed`
            });
            onComplete({
                message: NaturalDisasterConstants.FAILURE_FORBEARANCE_MESSAGE,
                toastType: ToastType.ERROR
            });
        }
    });
};
